/* eslint-disable */

export const SmallMedalIcon = (props: any) => (
  <svg
    width={12}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.375.375 3.051 6.84a5.508 5.508 0 0 0-1.934 2.012 5.502 5.502 0 0 0-.742 2.793c0 1.002.254 1.94.762 2.812a5.835 5.835 0 0 0 2.031 2.031A5.533 5.533 0 0 0 6 17.25c1.016 0 1.96-.254 2.832-.762a5.835 5.835 0 0 0 2.031-2.031c.508-.872.762-1.81.762-2.813a5.502 5.502 0 0 0-.742-2.792 5.404 5.404 0 0 0-1.914-1.993L11.625.375h-1.348L7.836 6.313a6.57 6.57 0 0 0-1.29-.293L8.872.375H7.523L5.18 6.059c-.352.052-.69.136-1.016.253L1.723.375H.375Zm2.754 0L4.73 4.242l.665-1.66L4.477.375H3.129ZM6 7.25c.794 0 1.523.195 2.188.586.677.39 1.21.924 1.601 1.601.39.665.586 1.394.586 2.188a4.34 4.34 0 0 1-.586 2.207 4.342 4.342 0 0 1-1.601 1.582A4.236 4.236 0 0 1 6 16a4.34 4.34 0 0 1-3.79-2.168 4.34 4.34 0 0 1-.585-2.207c0-.794.195-1.523.586-2.188.39-.677.918-1.21 1.582-1.601A4.34 4.34 0 0 1 6 7.25Zm0 1.973-.723 1.64-1.777.196 1.328 1.191-.371 1.758L6 13.109l1.543.899-.371-1.758L8.5 11.059l-1.777-.196L6 9.223Z"
      fill="#2D5BFF"
    />
  </svg>
);
